import { eventBus } from "./main";

if (process.env.NODE_ENV === "productionWithCacheEnabled") {
// if (process.env.NODE_ENV === "production") {
  if ("serviceWorker" in navigator) {
    if (!navigator.serviceWorker.controller) {
      navigator.serviceWorker.register("./sw.js", {
        scope: "./"
      });
    }
  }

  window.addEventListener("beforeinstallprompt", function (event) {
    event.preventDefault();
    window.installPrompt = event;
    eventBus.$emit("installPromptFired");
    return false;
  });

} else {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        for (let sw of registrations) {
          sw.unregister();
        }
      });
  }
}
